if ($("#vue-slider").length) {
    new Vue({
        el: "#vue-slider",
        data: {
            currentSlide: 0,
            slider: "",
        },
        mounted() {
            // alert(1);
            let vm = this;
            let slider = new Swiper(this.$refs.sliderContainer, {
                slidesPerView: 1,
                // loop: true,
                prevButton: ".slider__button_prev",
                nextButton: ".slider__button_next",
                // pagination: ".slider__pagination",
                // paginationClickable: true,
                centeredSlides: true,
                autoplay: 8000,
                // observer: true,
                // preloadImages: false,
                // lazyLoading: true,
                // watchSlidesVisibility: true,
                // lazyLoadingInPrevNext: true,
                // lazyLoadingInPrevNextAmount: 1,
                onSlideChangeStart: function(swiper) {
                    // console.log(swiper.activeIndex);
                    vm.currentSlide = swiper.activeIndex;
                }
            });
            this.slider = slider;
        },
        methods: {
            changeSlide(index) {
                // alert(index);
                this.slider.slideTo(index);
            }
        }
    });
}



// WEBPACK FOOTER //
// ./vue/slider.js